import {Profile} from 'src/modules'

export const ProfilePage = () => {
  return <Profile />
}
